import { HttpErrorResponse } from "@angular/common/http";

import { CountryModel } from "@models/country.model";
import { createReducer, on } from "@ngrx/store";

import {
  COUNTRY_ACTION_FAILURE,
  SET_COUNTRIES,
  SET_COUNTRIES_LOADING,
} from "./country.actions";

export interface CountryState {
  countriesLoading: boolean;
  countries: CountryModel[];
  error: HttpErrorResponse | null;
}

const initialState: CountryState = {
  countriesLoading: false,
  countries: [],
  error: null,
};

export const COUNTRY_REDUCER = createReducer(
  initialState,
  on(COUNTRY_ACTION_FAILURE, (state, action): CountryState => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(
    SET_COUNTRIES_LOADING,
    (state: CountryState, action: { loading: boolean }): CountryState => {
      return {
        ...state,
        countriesLoading: action.loading,
      };
    }
  ),

  on(
    SET_COUNTRIES,
    (state: CountryState, action: { data: CountryModel[] }): CountryState => {
      return {
        ...state,
        countries: action.data,
      };
    }
  )
);
